module.exports = window.COS;


//////////////////
// WEBPACK FOOTER
// external "window.COS"
// module id = 7yPv
// module chunks = 12